import { ChannelPlayerProgram } from '../types/channel-player-program';

export const getCurrentProgram = (
    programs: ChannelPlayerProgram[] | undefined,
    now: number = Date.now()
): ChannelPlayerProgram | undefined =>
    programs?.find(
        ({ startTime, endTime }) => startTime.getTime() < now && now < endTime.getTime()
    );
